import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminStatsConversions = lazy(() => import("@/pages/admin/AdminStatsConversions"));

export const Route = createFileRoute("/admin/statistik/konverteringar/")({
  component: () => <AdminStatsConversions />,
});
